interface ILocalStorageItem {
	value: string;
	expirationDate: Date;
}

let storageOverride: Storage | null;
let getDateOverride: (() => Date) | null;

const defaultGetDate = () => new Date();

export const overrideStorage = (storage: Storage | null) => {
	storageOverride = storage;
};

export const overrideGetDate = (getDate: (() => Date) | null) => {
	getDateOverride = getDate;
};

const getStorage = () => {
	return storageOverride ?? localStorage;
};

const getDate = () => {
	return (getDateOverride ?? defaultGetDate)();
};

export function setInLocalStorage(name: string, value: string, nDays: number) {
	const date = getDate();
	date.setDate(date.getDate() + nDays);

	const data: ILocalStorageItem = {
		value: value,
		expirationDate: date,
	};
	getStorage().setItem("cookie-" + name, JSON.stringify(data));
}

export function getFromLocalStorage(name: string): string | null {
	const item = JSON.parse(getStorage().getItem("cookie-" + name)!) as ILocalStorageItem;

	if (item !== null && new Date(item.expirationDate).getTime() >= getDate().getTime()) {
		return item.value;
	}

	return null;
}
